import axios from 'axios'
import { Toast } from 'vant'
import router from '@/router'

const service = axios.create({
  baseURL: '/api',
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

service.interceptors.request.use((config) => {
  const token = window.localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

service.interceptors.response.use(
  (res) => res,
  (err) => {
    const msg = (err.response && err.response.data && err.response.data.message) || err.message || '请求失败'
    const silent = err.config && err.config.silent
    if (err.response && err.response.status === 401 && !silent) {
      localStorage.removeItem('token')
      localStorage.removeItem('phone')
      localStorage.removeItem('user_info')
      router.replace('/login')
    }
    if (!silent) Toast(msg)
    return Promise.reject(err)
  }
)

/** 登录（密码） */
export function login(data) {
  return service({
    url: '/auth/user/login',
    method: 'post',
    data
  })
}

/** 短信验证码登录（兼容 / 万能登录码） */
export function smsLogin(data, opts = {}) {
  return service({
    url: '/auth/user/sms-login',
    method: 'post',
    data,
    ...opts
  })
}

/** 获取图形验证码 */
export function fetchCaptcha() {
  return service({
    url: '/auth/captcha',
    method: 'get'
  })
}

/** 手机号 + 图形验证码登录（支持万能登录码） */
export function captchaLogin(data, opts = {}) {
  return service({
    url: '/auth/user/captcha-login',
    method: 'post',
    data,
    ...opts
  })
}

/** 在线客服：创建/获取会话 */
export function csEnsureSession(data) {
  return service({
    url: '/cs/user/session',
    method: 'post',
    data
  })
}

/** 在线客服：拉取消息 */
export function csFetchMessages(params, opts = {}) {
  return service({
    url: '/cs/user/messages',
    method: 'get',
    params,
    ...opts
  })
}

/** 在线客服：未读数（Tab 红标） */
export function csUnread(opts = {}) {
  return service({
    url: '/cs/user/unread',
    method: 'get',
    silent: true,
    ...opts
  })
}

/** 在线客服：发送消息 */
export function csSendMessage(data) {
  return service({
    url: '/cs/user/messages',
    method: 'post',
    data
  })
}

/** 在线客服：发送图片 */
export function csSendImage(formData) {
  return service({
    url: '/cs/user/image',
    method: 'post',
    data: formData,
    timeout: 60000
  })
}

/** 合同列表 */
export function contracts() {
  return service({
    url: '/user/contracts',
    method: 'get'
  })
}

/** 合同详情 */
export function contractDetail(id) {
  return service({
    url: `/user/contracts/${id}`,
    method: 'get'
  })
}

/** 确认合同 */
export function agreeContract(id) {
  return service({
    url: `/user/contracts/${id}/agree`,
    method: 'post'
  })
}

/** 结清证明列表 */
export function settlementCerts() {
  return service({
    url: '/user/settlement-certs',
    method: 'get'
  })
}

/** 结清证明详情 */
export function settlementCert(id) {
  return service({
    url: `/user/contracts/${id}/settlement-cert`,
    method: 'get'
  })
}

/** 账单列表 status=pending|paid */
export function bills(status) {
  return service({
    url: '/user/bills',
    method: 'get',
    params: status ? { status } : {}
  })
}

/** 还款 */
export function repayBill(id, data = {}) {
  return service({
    url: `/user/bills/${id}/repay`,
    method: 'post',
    data
  })
}

/** 一次性还清全部待还 */
export function repayAll(data = {}) {
  return service({
    url: '/user/repay-all',
    method: 'post',
    data
  })
}

/** 可用支付渠道 */
export function payChannels() {
  return service({
    url: '/user/channels',
    method: 'get'
  })
}

/** 查询支付单 */
export function payQuery(tradeNo) {
  return service({
    url: '/user/pay/query',
    method: 'get',
    params: { trade_no: tradeNo }
  })
}

/** 还款记录 */
export function repayments() {
  return service({
    url: '/user/repayments',
    method: 'get'
  })
}

// ---- 兼容旧页面调用名 ----
export function repayment() {
  return bills()
}

export function seven() {
  return bills('pending')
}

export function banklist() {
  return Promise.resolve({ data: [] })
}

export function addbank() {
  return Promise.reject(new Error('当前版本不支持绑卡'))
}

export function borrow() {
  return Promise.reject(new Error('当前版本不支持在线申请借款'))
}

export function limitmoney() {
  return Promise.resolve({ data: { data: 0 } })
}

export function signup() {
  return Promise.reject(new Error('请联系管理员导入账号'))
}

export function sendsms() {
  return Promise.reject(new Error('当前版本不支持短信'))
}

export function modify() {
  return Promise.reject(new Error('请联系管理员重置密码'))
}

export default service
